import React from 'react';
import { Route } from 'react-router-dom';
import { withRouter } from "react-router";

const AppRoutes = ({ component: Component, path, config, auth, onCallBack, isPrivate, ...rest }) => {
	
	
	//console.log('path:', path);
	//console.log('config:', config);
	//console.log('auth:', auth);
	//console.log('onCallBack:', onCallBack);
	//console.log('isPrivate:', isPrivate);		
	
	return (
		<Route
			path={path}
			exact={true}
            render={(props) => <Component {...props} exact config={config} path={path} auth={auth} onCallBack={onCallBack} />}
		/>
	);
};

export default withRouter(AppRoutes);
